import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import isEmpty from 'lodash/isEmpty';
import { withStyles, createMuiTheme, responsiveFontSizes } from '@material-ui/core/styles';
import { Grid, Typography, Card, CardContent, Icon } from '@material-ui/core';

import Button from '../../core/components/Button';
import MapComponent from './MapComponent';
import HoursComponent from './HoursComponent';
import * as Functions from '../../../services/functions/Functions';
import * as Routes from '../../../services/routes/Routes.json';
import { getCurrentOrder } from '../../../selectors';
import * as FeatureFlags from '../../../../feature-flags.json';
import styles from '../../../css/locationsPage/subComponents/LocationComponent.scss';
import * as ResponsiveStyles from '../../../../jsonStyles/components/locationsPage/subComponents/LocationComponent.style.json';

let theme = createMuiTheme();
const responsiveStyles = typeof styles === 'function' ? styles() : styles;
theme = responsiveFontSizes(theme);

responsiveStyles.card = {
  ...responsiveStyles.card,
  [theme.breakpoints.down('sm')]: {
    width: ResponsiveStyles.card.width,
    maxWidth: ResponsiveStyles.card.maxWidth,
    height: ResponsiveStyles.card.height,
    margin: ResponsiveStyles.card.margin,
  },
};

responsiveStyles.mapStyle = {
  ...responsiveStyles.mapStyle,
  [theme.breakpoints.down('sm')]: {
    width: ResponsiveStyles.mapStyle.width,
    maxWidth: ResponsiveStyles.mapStyle.maxWidth,
  },
};

responsiveStyles.icon = {
  ...responsiveStyles.icon,
  [theme.breakpoints.down('sm')]: {
    fontSize: ResponsiveStyles.icon.fontSize,
  },
};

class LocationComponent extends Component {
  handleClickOrderHere = () => {
    const { actions, currentOrder, location } = this.props;
    const orderObj = {};
    // Set location
    orderObj.location = location;
    // Create Order
    if (!isEmpty(orderObj)) {
      actions.createOrder(null, {
        ...currentOrder,
        ...orderObj,
      });
    }
    // Redirect to menu page
    this.props.history.push(Routes.path.menuPage);
  }

  render() {
    const {
      location,
      classes,
      translation,
      history,
    } = this.props;
    const infoGrid = [
      { icon: null, info: location.name.toUpperCase(), infoFormat: classes.locationName },
      { icon: 'place_icon', info: Functions.parseAddress(location.address), infoFormat: classes.locationText },
      { icon: 'local_phone', info: location.phone, infoFormat: classes.locationText },
    ];
    // Inclusion of the radix "10" per ESLint rule for ES6
    return (
      <Card className={classes.card} id={`locationComponent${location.id}`}>
        <CardContent>
          <Grid container spacing={parseInt(responsiveStyles.grid.spacing, 10)}>
            <Grid item xs={parseInt(responsiveStyles.grid.xsMap, 10)}>
              <MapComponent
                location={location}
                translation={translation}
                history={history}
                containerStyle={responsiveStyles.mapContainer}
                mapStyle={responsiveStyles.mapStyle}
              />
            </Grid>
            {
              infoGrid.map((x, i) => (
                <Grid container spacing={parseInt(responsiveStyles.grid.spacing, 10)} key={i}>
                  {
                    x.icon
                      && (
                        <Grid className={classes.iconGrid} item xs={parseInt(responsiveStyles.grid.xsIcon, 10)}>
                          <Icon className={classes.icon} color={responsiveStyles.grid.color}>{x.icon}</Icon>
                        </Grid>
                      )
                  }
                  <Grid item xs={parseInt(x.icon ? responsiveStyles.grid.xsInfo : responsiveStyles.grid.xsMap, 10)}>
                    <Typography className={x.infoFormat}>{x.info}</Typography>
                  </Grid>
                </Grid>
              ))
            }
            <Grid container spacing={parseInt(responsiveStyles.grid.spacing, 10)} key="hoursGrid">
              <Grid className={classes.iconGrid} item xs={parseInt(responsiveStyles.grid.xsIcon, 10)}>
                <Icon className={classes.icon} color={responsiveStyles.grid.color}>access_alarm</Icon>
              </Grid>
              <Grid item xs={parseInt(responsiveStyles.grid.xsInfo, 10)}>
                <HoursComponent
                  hours={location.hours}
                  translation={translation}
                  textcolorOverride={responsiveStyles.hoursText.color}
                  location={location}
                />
              </Grid>
            </Grid>
          </Grid>
          <Button
            type="primary"
            onClick={this.handleClickOrderHere}
            fullWidth
            text={translation('LocationComponent.orderHere')}
          />
        </CardContent>
      </Card>
    );
  }
}

LocationComponent.propTypes = {
  classes: PropTypes.objectOf(PropTypes.string).isRequired,
  translation: PropTypes.func.isRequired,
  location: PropTypes.objectOf(PropTypes.any).isRequired,
  history: PropTypes.objectOf(PropTypes.any).isRequired,
  actions: PropTypes.objectOf(PropTypes.func).isRequired,
  currentOrder: PropTypes.objectOf(PropTypes.any),
};

LocationComponent.defaultProps = {
  currentOrder: {},
};

const mapStateToProps = state => ({
  currentOrder: getCurrentOrder(state),
});

export default withStyles(responsiveStyles)(connect(mapStateToProps)(LocationComponent));
